import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.concat.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-59104380"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  style: {
    "padding": "20px"
  }
};
var _hoisted_2 = {
  class: "flex-v-center"
};
var _hoisted_3 = {
  class: "mr5"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "> 审批详情页", -1);
});

var _hoisted_5 = {
  class: "white-box mt20"
};
var _hoisted_6 = {
  class: "con-ul"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "title"
  }, "权限来源：", -1);
});

var _hoisted_8 = {
  class: "title"
};
var _hoisted_9 = {
  key: 1
};
var _hoisted_10 = {
  key: 0,
  class: "mt20 ta-c"
};
var _hoisted_11 = {
  key: 1,
  class: "mt20 ta-c"
};

var _hoisted_12 = /*#__PURE__*/_createTextVNode("通过 ");

var _hoisted_13 = /*#__PURE__*/_createTextVNode("驳回 ");

import { myApproveHeader } from './commons/tableHeader';
import { getApprovalHistoryDesc, doApprove, editAuthApprove } from './commons/authUtil';
import { ref, reactive, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import AuthService from '@/api/auth';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var route = useRoute();
    var router = useRouter();
    var detailHeader = ref([]);
    var detailApply = reactive({
      modifyId: '',
      modifyList: []
    });
    var tableOptions = reactive({
      loading: true
    });
    var statusObj = ref({
      REJECT: '拒绝',
      PASS: '通过'
    });
    var appKeyObj = ref({
      data_talk: 'dataTalk',
      beacon_olap: '灯塔分析',
      data_link: 'dataLink',
      tkdsee: '远见应用'
    });

    var searchList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _data$data;

        var data, result, otherObj;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return AuthService.handlerQuery({
                  applyId: route.params.applyId
                });

              case 2:
                data = _context.sent;
                tableOptions.loading = false;

                if (!(((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1)) {
                  _context.next = 12;
                  break;
                }

                result = data.data.result;
                _context.next = 8;
                return getApprovalHistoryDesc(result.approvalHistory, result.approvalStep);

              case 8:
                otherObj = _context.sent;
                Object.assign(detailApply, result, {
                  modifyName: result.actionDesc || result.roleName,
                  modifyId: result.action || result.roleId,
                  modifyList: []
                }, otherObj);
                editAuthApprove(detailApply); // 一级二级审批人

                Object.keys(detailApply.authProcessVO).forEach(function (key) {
                  var approvers = [];
                  detailApply.authProcessVO[key].forEach(function (item) {
                    approvers.push(item.name);
                  });
                  detailApply[key] = approvers.join(';');
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function searchList() {
        return _ref.apply(this, arguments);
      };
    }(); // 审批通过或驳回


    var approve = function approve(row, approvalResult) {
      tableOptions.loading = true;
      doApprove(row, approvalResult, searchList);
    };

    onMounted(function () {
      searchList();
      detailHeader.value = myApproveHeader.concat([{
        title: '一级审批人',
        key: 'first_approvers'
      }, {
        title: '二级审批人',
        key: 'second_approvers'
      }]);
    });
    return function (_ctx, _cache) {
      var _component_el_option = _resolveComponent("el-option");

      var _component_el_select = _resolveComponent("el-select");

      var _component_circle_check = _resolveComponent("circle-check");

      var _component_el_icon = _resolveComponent("el-icon");

      var _component_el_button = _resolveComponent("el-button");

      var _component_circle_close = _resolveComponent("circle-close");

      var _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h2", _hoisted_3, [_createTextVNode(_toDisplayString(_unref(route).params.biz_url) + " ", 1), _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _unref(router).push({
            name: 'AuthDefault',
            params: {
              biz_url: _unref(route).params.biz_url
            }
          });
        })
      }, "权限中心")]), _hoisted_4]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("ul", _hoisted_6, [_createElementVNode("li", null, [_hoisted_7, _createTextVNode(_toDisplayString(appKeyObj.value[_unref(detailApply).appKey]), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailHeader.value, function (item, idx) {
        return _openBlock(), _createElementBlock("li", {
          key: idx
        }, [_createElementVNode("span", _hoisted_8, _toDisplayString(item.title) + "：", 1), item.key === 'modifyName' && _unref(detailApply).canApprove ? (_openBlock(), _createBlock(_component_el_select, {
          key: 0,
          modelValue: _unref(detailApply).modifyId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
            return _unref(detailApply).modifyId = $event;
          }),
          size: "mini"
        }, {
          default: _withCtx(function () {
            return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(detailApply).modifyList, function (item) {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))];
          }),
          _: 2
        }, 1032, ["modelValue"])) : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(detailApply)[item.key] || '无'), 1))]);
      }), 128))]), _unref(detailApply).applyStatus !== 'APPROVING' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("b", null, "该单已经被" + _toDisplayString(statusObj.value[_unref(detailApply).applyStatus]) + "，审批流程已结束", 1)])) : _unref(detailApply).canApprove ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_el_button, {
        type: "success",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return approve(_unref(detailApply), 'PASS');
        })
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_icon, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_circle_check)];
            }),
            _: 1
          }), _hoisted_12];
        }),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "danger",
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return approve(_unref(detailApply), 'REJECT');
        })
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_icon, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_circle_close)];
            }),
            _: 1
          }), _hoisted_13];
        }),
        _: 1
      })])) : _createCommentVNode("", true)])), [[_directive_loading, _unref(tableOptions).loading]])]);
    };
  }
});